/**
 * 공공데이터 전문성 섹션 — 회사의 공공데이터 역량을 `운영`과 `개방` 두 축으로 요약.
 * 운영(중립/그레이) · 개방(강조/브랜드 레드) 카드를 균형 있게 배치하고,
 * 국가중점데이터 개방사업 국내 최다 실적을 부각한다. 정적 프레젠테이션(상태 없음).
 *
 * @param openCount 국가중점데이터 개방사업 수행 건수(시안 임시값). 확정 시 교체.
 * @param showBadge 「국내 최다 실적」 배지 노출 여부.
 */
export default function PublicDataExpertise({
  openCount = '20+',
  showBadge = true,
}: {
  openCount?: string;
  showBadge?: boolean;
}) {
  return (
    <div className="mh-pde">
      <div className="mh-pde__head">
        <span className="mh-eyebrow">PUBLIC DATA</span>
        <h2 className="mh-pde__title">공공데이터, 운영부터 개방까지</h2>
        <div className="mh-pde__rule" />
        <p className="mh-pde__lead">
          국가 공공데이터를 <b>안정적으로 운영</b>하고, 가치 있는 데이터를 <b>새롭게 개방</b>합니다.
          <br />
          공공데이터 개방부터 포털 운영까지 축적된 전문성으로 신뢰받는 공공데이터 개방 구축을 실현합니다.
        </p>
      </div>

      <div className="mh-pde__grid">
        {/* 공공데이터 운영 (중립 / 그레이) */}
        <div className="mh-pde-card">
          <div className="mh-pde-card__accent" />
          <div className="mh-pde-card__titlerow">
            <span className="mh-pde-card__name">공공데이터 운영</span>
            <span className="mh-pde-card__en">OPERATION</span>
          </div>
          <p className="mh-pde-card__desc">국가 공공데이터포털과 대국민 서비스를 직접 운영합니다.</p>

          <div className="mh-pde-card__metric">
            <span className="mh-pde-card__num">
              10<span className="mh-pde-card__unit">년+</span>
            </span>
            <span className="mh-pde-card__cap">
              공공데이터포털(data.go.kr)
              <br />
              연속 위탁운영
            </span>
          </div>

          <div className="mh-pde-card__divider" />

          <ul className="mh-pde-card__list">
            <li className="mh-pde-card__li">공공데이터포털·대국민 서비스 위탁운영</li>
            <li className="mh-pde-card__li">범정부 데이터 플랫폼 통합 운영</li>
            <li className="mh-pde-card__li">서비스 개선 · 유지관리</li>
            <li className="mh-pde-card__li">대국민 데이터 활용 지원 · 운영 고도화</li>
          </ul>
        </div>

        {/* 공공데이터 개방 (강조 / 브랜드 레드) */}
        <div className="mh-pde-card mh-pde-card--accent">
          <span className="mh-pde-card__stripe" aria-hidden />
          <span className="mh-pde-card__glow" aria-hidden />

          <div className="mh-pde-card__accent mh-pde-card__accent--red" />

          <div className="mh-pde-card__titlerow">
            <span className="mh-pde-card__name">공공데이터 개방</span>
            <span className="mh-pde-card__en mh-pde-card__en--red">OPENING</span>
          </div>
          <p className="mh-pde-card__desc">활용 가치가 높은 국가중점데이터를 새롭게 발굴·개방합니다.</p>

          <div className="mh-pde-card__metric">
            <span className="mh-pde-card__num mh-pde-card__num--red">{openCount}</span>
            <span className="mh-pde-card__cap">
              국가중점데이터
              <br />
              개방사업 수행
            </span>
            {showBadge && <span className="mh-pde-card__badge">국내 최다 실적</span>}
          </div>

          <div className="mh-pde-card__divider" />

          <ul className="mh-pde-card__list mh-pde-card__list--red">
            <li className="mh-pde-card__li">
              <b>[법제처]</b> 법령해석 · 재결례 개방체계 구축
            </li>
            <li className="mh-pde-card__li">
              <b>[국토교통부]</b> 사업용차량 이력정보 개방체계 구축
            </li>
            <li className="mh-pde-card__li">
              <b>[금융위원회]</b> 금융표준종합정보 DB 개방
            </li>
            <li className="mh-pde-card__li">
              <b>[국세청]</b> 사업자등록정보 진위확인 API
            </li>
          </ul>
        </div>
      </div>

      <a className="mh-cta mh-pde__more" href="/data">
        공공데이터 사업 자세히 보기 →
      </a>
    </div>
  );
}
